import { render, staticRenderFns } from "./RightMenuItem.vue?vue&type=template&id=9c55969a&scoped=true&"
import script from "./RightMenuItem.vue?vue&type=script&lang=js&"
export * from "./RightMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./RightMenuItem.vue?vue&type=style&index=0&id=9c55969a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c55969a",
  null
  
)

export default component.exports